export default {
  sucursalSeleccionada: null,
}